export { SignalRService, SignalRConfig, SignalRConnectionState } from './signalr.service';
export { ScoringRealtimeService as GolfScoringRealtimeService } from './scoring-realtime.service';
export * from './signalr.types';
export { LogLevel, HubConnectionState } from '@microsoft/signalr';
